import type { VendorIntegration } from '@onefootprint/request-types/dashboard';

type IntegrationOption = { value: string; label: string };

// Integrations are registered per vendor and a catalog row is one of that vendor's APIs, so a row
// offers a choice only when its vendor has several. The API lists them oldest first, and the oldest
// is what a tool without an id runs against.
const integrationOptionsForKind = (integrations: VendorIntegration[], kind: string): IntegrationOption[] =>
  integrations.flatMap(integration =>
    integration.id && integration.apis.some(api => api.kind === kind)
      ? [{ value: integration.id, label: integration.integrationName ?? integration.name }]
      : [],
  );

export type { IntegrationOption };
export { integrationOptionsForKind };
